{
  "removeButtonLabel": "Eliminar",
  "removeDescription": "Prima Delete para eliminar a tag."
}
